import React from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "app/utils/constants/routeConstants";
import { PaginationDropdown } from "components/Pagination";
import SearchInput from "components/SearchInput";

const Filters = ({
  languages,
  languageFilter,
  onLanguageFilterChange,
  searchQuery,
  onSearchQueryChange,
  rowsPerPage,
  onRowsPerPageChange,
}) => {
  const navigate = useNavigate();
  const getLanguageDisplay = (key) => {
    const language = languages.find((lang) => lang.key === key);
    return language ? language.value : "Filter";
  };

  const getTooltipTitle = () => {
    if (!languageFilter) {
      return "Filter by Programming Language";
    }
    return `Filtered by ${getLanguageDisplay(languageFilter)}`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexWrap: { xs: "wrap", sm: "nowrap" },
        gap: 2,
        paddingTop: 1,
      }}
    >
      <FormControl
        sx={{
          m: 1,
          minWidth: 30,
          width: 120,
          "& .MuiOutlinedInput-root": { borderRadius: "16px" },
        }}
        size="small"
      >
        <Tooltip title={getTooltipTitle()} placement="top" arrow>
          <Select
            value={languageFilter}
            onChange={(e) => onLanguageFilterChange(e.target.value)}
            displayEmpty
            renderValue={(selected) => (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <InputAdornment position="start">
                  <TuneIcon />
                </InputAdornment>
                {getLanguageDisplay(selected)}
              </Box>
            )}
          >
            <MenuItem value="">All Languages</MenuItem>
            {languages.map((lang) => (
              <MenuItem key={lang.key} value={lang.key}>
                {lang.value}
              </MenuItem>
            ))}
          </Select>
        </Tooltip>
      </FormControl>

      <FormControl
        sx={{
          m: 1,
          minWidth: 100,
          width: { xs: "100%", sm: 400 },
          display: "flex",
          justifyContent: "center",
        }}
        size="small"
      >
        <SearchInput
          value={searchQuery}
          onChange={onSearchQueryChange}
          label="Search by title"
          type="search"
          sx={{ flexGrow: 1 }}
        />
      </FormControl>
      <PaginationDropdown
        isAdmin={true}
        addLabel="Add content"
        addRoute={ROUTES.ADMIN_PROGRAMMING_CONTENT_ADD}
        navigate={navigate}
        rows={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </Box>
  );
};

export default Filters;
